module.exports = __webpack_public_path__ + "static/media/language_feature.48b2d9f5.png";